<template>
	<div class="container xl:container w-full">
		<slot />
	</div>
</template>
